import { render, staticRenderFns } from "./MomentosContablesCard.vue?vue&type=template&id=10b58e22&scoped=true&"
import script from "./MomentosContablesCard.vue?vue&type=script&lang=js&"
export * from "./MomentosContablesCard.vue?vue&type=script&lang=js&"
import style0 from "./MomentosContablesCard.vue?vue&type=style&index=0&id=10b58e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b58e22",
  null
  
)

export default component.exports